/* --- CHEFKOCH CUSTOM: Fortschrittsbalken Logik (Stabil, Premium Highlight, CH-Währungsformat, Logistik-Sync & Dynamische Tooltips) --- */

function initChefkochProgressBar() {
    const wrapper = document.querySelector('.chefkoch-progress-wrapper');
    if (!wrapper) return;

    let currentTotal = parseInt(wrapper.getAttribute('data-cart-total'), 10) || 0;
    
    const hasShipping = wrapper.getAttribute('data-shipping-enabled') === 'true';
    let shippingThreshold = parseInt(wrapper.getAttribute('data-shipping-threshold'), 10) || 0;
    const shippingSuccessMsg = wrapper.getAttribute('data-shipping-success');
    
    const hasGift = wrapper.getAttribute('data-gift-enabled') === 'true';
    let giftThreshold = parseInt(wrapper.getAttribute('data-gift-threshold'), 10) || 0;
    const giftSuccessMsg = wrapper.getAttribute('data-gift-success');
    const giftName = wrapper.getAttribute('data-gift-name') || 'Gratis-Gewürz'; // Dynamischer Name für Tooltip

    const statusTextContainer = document.getElementById('chefkoch-progress-status-text');
    const achievedListContainer = document.getElementById('chefkoch-progress-achieved-list');
    const barFill = document.getElementById('chefkoch-progress-bar-fill');

    if (!statusTextContainer || !barFill) return;

    let maxThreshold = 0;
    if (hasShipping && shippingThreshold > maxThreshold) maxThreshold = shippingThreshold;
    if (hasGift && giftThreshold > maxThreshold) maxThreshold = giftThreshold;

    if (maxThreshold === 0) {
        wrapper.style.display = 'none';
        return;
    } else {
        wrapper.style.display = 'block';
    }

    // 1. Balkenbreite
    let percentage = (currentTotal / maxThreshold) * 100;
    percentage = Math.max(0, Math.min(percentage, 100));
    barFill.style.width = percentage + '%';

    // 2. Meilenstein-Punkte
    const giftMarker = document.getElementById('chefkoch-gift-marker');
    if (giftMarker && hasGift) {
        let giftPos = (giftThreshold / maxThreshold) * 100;
        giftMarker.style.left = giftPos + '%';
        currentTotal >= giftThreshold ? giftMarker.classList.add('reached') : giftMarker.classList.remove('reached');
    }

    const shippingMarker = document.getElementById('chefkoch-shipping-marker');
    if (shippingMarker && hasShipping) {
        let shipPos = (shippingThreshold / maxThreshold) * 100;
        shippingMarker.style.left = shipPos + '%';
        currentTotal >= shippingThreshold ? shippingMarker.classList.add('reached') : shippingMarker.classList.remove('reached');
    }

    // 3. Meilensteine mit Premium-Hervorhebung
    let milestonesHTML = '';
    
    const successIcon = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2a7a40" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="min-width:18px;"><path d="M20 6L9 17l-5-5"></path></svg>`;
    const pendingIcon = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(var(--color-foreground), 0.25)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="min-width:18px;"><circle cx="12" cy="12" r="10"></circle></svg>`;

    const successStyle = `padding: 0.8rem 1.4rem; background-color: rgba(var(--color-foreground), 0.03); color: rgba(var(--color-foreground), 0.9); border-radius: 0.6rem;`;
    const pendingStyle = `padding: 0.4rem 1.4rem; background-color: transparent; color: rgba(var(--color-foreground), 0.6);`;
    const highlightStyle = `color: #2F7F78; font-size: 1.15em; font-weight: 700; white-space: nowrap; margin: 0 0.3rem;`;

    // --- HILFSFUNKTION FÜR DAS INFO-ICON ---
    function getInfoIcon(text) {
        return `
        <span class="chefkoch-info-tooltip" tabindex="0">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <title>${text}</title>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span class="chefkoch-tooltip-text">${text}</span>
        </span>`;
    }

    // --- CHEFKOCH CUSTOM START: HTML-Feld synchron halten ---
    const hiddenGiftInput = document.getElementById('chefkoch-gift-attribute');
    if (hiddenGiftInput) {
        hiddenGiftInput.value = (hasGift && currentTotal >= giftThreshold) ? giftName : '';
    }
    // --- CHEFKOCH CUSTOM END ---

    // Check 1: Gratis Geschenk
    if (hasGift) {
        let thresholdCHF = (giftThreshold / 100).toFixed(2);
        
        if (currentTotal >= giftThreshold) {
            let tooltipText = `Gratisartikel ${giftName} wird automatisch mit deiner Bestellung versendet. Artikel ist nicht im Kassenbereich sichtbar.`;
            milestonesHTML += `<div class="chefkoch-success-row" style="${successStyle}; display: flex; align-items: center;">${successIcon}<span style="display: flex; align-items: center; margin-left: 0.5rem;">${giftSuccessMsg} ${getInfoIcon(tooltipText)}</span></div>`;
        } else {
            let diffGift = ((giftThreshold - currentTotal) / 100).toFixed(2);
            let tooltipText = `Ab CHF ${thresholdCHF} schenken wir dir eine Dose ${giftName}.`;
            milestonesHTML += `<div class="chefkoch-success-row" style="${pendingStyle}; display: flex; align-items: center;">${pendingIcon}<span style="display: flex; align-items: center; margin-left: 0.5rem;">Noch <strong style="${highlightStyle}">CHF ${diffGift}</strong> bis zum Gratis-Geschenk ${getInfoIcon(tooltipText)}</span></div>`;
        }
    }

    // Check 2: Gratis Versand
    if (hasShipping) {
        let thresholdCHF = (shippingThreshold / 100).toFixed(2);

        if (currentTotal >= shippingThreshold) {
            let tooltipText = `Du hast dir deinen kostenlosen Versand gesichert.`;
            milestonesHTML += `<div class="chefkoch-success-row" style="${successStyle}; display: flex; align-items: center;">${successIcon}<span style="display: flex; align-items: center; margin-left: 0.5rem;">${shippingSuccessMsg} ${getInfoIcon(tooltipText)}</span></div>`;
        } else {
            let diffShip = ((shippingThreshold - currentTotal) / 100).toFixed(2);
            let tooltipText = `Sichere dir ab einem Bestellwert von CHF ${thresholdCHF} den kostenlosen Versand deiner Bestellung.`;
            milestonesHTML += `<div class="chefkoch-success-row" style="${pendingStyle}; display: flex; align-items: center;">${pendingIcon}<span style="display: flex; align-items: center; margin-left: 0.5rem;">Noch <strong style="${highlightStyle}">CHF ${diffShip}</strong> bis zum Gratis-Versand ${getInfoIcon(tooltipText)}</span></div>`;
        }
    }

    // Status Text Oben anpassen
    if (currentTotal >= maxThreshold) {
        statusTextContainer.innerHTML = `🎉 <strong>Glückwunsch!</strong> Du hast alle Ziele erreicht.`;
    } else {
        statusTextContainer.innerHTML = `Sichere dir jetzt deine Vorteile:`;
    }

    if (achievedListContainer) {
        achievedListContainer.style.gap = '0.2rem';
        achievedListContainer.innerHTML = milestonesHTML;
    }
}

// Initialisierung
document.addEventListener('DOMContentLoaded', initChefkochProgressBar);
if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(initChefkochProgressBar, 1);
}
document.addEventListener('shopify:section:load', initChefkochProgressBar);

// --- CHEFKOCH CUSTOM: Gratis-Geschenk auch beim Seitenaufruf zu Shopify synchronisieren ---
async function syncChefkochGiftAttributeOnLoad() {
    const hiddenGiftInput = document.getElementById('chefkoch-gift-attribute');
    if (!hiddenGiftInput) return;

    try {
        await fetch(window.Shopify.routes.root + 'cart/update.js?chefkoch_sync=1', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                attributes: {
                    'Gratis-Geschenk': hiddenGiftInput.value || ''
                }
            })
        });
    } catch (error) {
        console.error('Chefkoch Gratis-Geschenk Initial-Sync Error:', error);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(syncChefkochGiftAttributeOnLoad, 100);
});

if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(syncChefkochGiftAttributeOnLoad, 100);
}

document.addEventListener('shopify:section:load', () => {
    setTimeout(syncChefkochGiftAttributeOnLoad, 100);
});
// --- CHEFKOCH CUSTOM END ---

// Fetch Interceptor für Live-Updates (Der Goldstandard-Fix für Dawn)
const originalFetch = window.fetch;
window.fetch = async function() {
    const response = await originalFetch.apply(this, arguments);
    let requestUrl = (typeof arguments[0] === 'string') ? arguments[0] : (arguments[0] instanceof Request ? arguments[0].url : '');
    
    // Wir reagieren auf jede Warenkorb-Veränderung von Dawn
    if (requestUrl.includes('/cart/change') || requestUrl.includes('/cart/add') || requestUrl.includes('/cart/update')) {
        if (!requestUrl.includes('chefkoch_sync')) {
            try {
                setTimeout(() => {
                    fetch(window.Shopify.routes.root + 'cart.js?chefkoch_sync=1')
                        .then(res => res.json())
                        .then(cart => {
                            if (cart && cart.total_price !== undefined) {
                                const wrapper = document.querySelector('.chefkoch-progress-wrapper');
                                if (wrapper) {
                                    wrapper.setAttribute('data-cart-total', cart.total_price);
                                    initChefkochProgressBar(); 

                                    // --- CHEFKOCH CUSTOM LOGISTIK-SYNC START ---
                                    const hasGift = wrapper.getAttribute('data-gift-enabled') === 'true';
                                    const giftThreshold = parseInt(wrapper.getAttribute('data-gift-threshold'), 10) || 0;
                                    const giftName = wrapper.getAttribute('data-gift-name'); 
                                    
                                    if (hasGift && giftName) {
                                        const currentAttr = cart.attributes ? cart.attributes['Gratis-Geschenk'] : null;
                                        
                                        if (cart.total_price >= giftThreshold && currentAttr !== giftName) {
                                            fetch(window.Shopify.routes.root + 'cart/update.js?chefkoch_sync=1', {
                                                method: 'POST',
                                                headers: { 'Content-Type': 'application/json' },
                                                body: JSON.stringify({ attributes: { 'Gratis-Geschenk': giftName } })
                                            });
                                        } else if (cart.total_price < giftThreshold && currentAttr) {
                                            fetch(window.Shopify.routes.root + 'cart/update.js?chefkoch_sync=1', {
                                                method: 'POST',
                                                headers: { 'Content-Type': 'application/json' },
                                                body: JSON.stringify({ attributes: { 'Gratis-Geschenk': '' } })
                                            });
                                        }
                                    }
                                    // --- CHEFKOCH CUSTOM LOGISTIK-SYNC END ---
                                }
                            }
                        }).catch(e => console.error("Chefkoch Sync Error:", e));
                }, 250);
            } catch (err) {}
        }
    }
    return response;
};